import { Color, FadeInOut } from 'excalibur';


export const inTransition = new FadeInOut({
    duration: 350,
    direction: 'in',
    color: Color.Black,
});
